import React, { useMemo } from 'react';
import cx from 'classnames';

import './styles.css';
import useBreakpoint from '@/hooks/useBreakpoint';

type Props = {
  label: string;
  value: string;
  icon?: React.ReactNode;
  onClick?(): void;
};

const ButtonPaymentMethod = ({ label, icon, value, onClick }: Props) => {
  const isActive = useMemo(() => {
    const isAutomaticDebit =
      label === 'Fatura' && value === 'Débito Automatico';
    const isInvoice = label === 'Conta Digital' && value === 'Fatura';

    return isAutomaticDebit || isInvoice || label === value;
  }, [label, value]);
  const { isOnBreakpoint: isTableOrLess } = useBreakpoint(1024);

  return (
    <button
      type='button'
      onClick={onClick}
      className={cx('buttonPaymentMethod', {
        'buttonPaymentMethod--active': isActive,
      })}
      style={{ marginBottom: isTableOrLess ? '11px' : '0px' }}
    >
      {icon}
      <span className='ml-4'>{label}</span>
    </button>
  );
};

export default ButtonPaymentMethod;
